import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsInquire({ page, size, direction, sort, },) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-inquire`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}
export function _delGoodsInquire(id) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}goods-inquire/${id}`,
    method: 'delete'
  });
}
export function _queryAppointment({ page, size, direction, sort, },) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/user-appointment`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}
export function _delAppointment(id) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/user-appointment/${id}`,
    method: 'delete'
  });
}

export function _queryRingSizer({ page, size, direction, sort, },) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-inquire`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

export function _queryNewsletter({ page, size, direction, sort, },) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/newsletter`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

export default {};
